import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { renderPlayerCell } from "./usePassingTable";
import { createTableData, teamGameLeaders } from "./utils";
import type { GetGameLeadersQuery } from "@/graphql/gql/graphql";

type Data = ReturnType<typeof teamGameLeaders>;

const createColumns = () => {
  const columnHelper = createColumnHelper<Data>();

  return [
    columnHelper.group({
      id: "rushing",
      header: "Rushing Yards",
      columns: [
        columnHelper.accessor("rushing_leader", {
          header: "Name",
          cell: renderPlayerCell,
        }),
        columnHelper.accessor("rushing_carries", {
          header: "ATT",
        }),
        columnHelper.accessor("rushing_yards", {
          header: "RUSH YDS",
        }),
        columnHelper.accessor("rushing_touchdowns", {
          header: "RUSH TDS",
        }),
      ],
    }),
  ];
};

const useRushingTable = (data: GetGameLeadersQuery["event"]) => {
  const tableData = useMemo(() => createTableData(data), [data]);
  const columns = useMemo(createColumns, []);
  return {
    columns,
    data: tableData,
  };
};

export default useRushingTable;
